


var bts = angular.module("bootstrap.sales", []);
require('services/wcs/ltpalogin')(bts);
bts.run(['appId', '$cookies', "link", "navigation", "brand", "sessionData", "hook","modal", function(appId, $cookies, link, navigation, brand, sessionData, hook,modal) {

	var salesProjects = ['MEDWEB','CHMPDR','CHMSHP','CLXCLP','CHMEMA'];
	var appIdUpperCase = appId && appId.toUpperCase();

	if(appIdUpperCase && salesProjects.indexOf(appIdUpperCase) === -1){
	    return;
	}

	var findDoctorModal = function() {
		modal.open({
			classes: "findDoctorModal",
			template: require('articles/findProviderModal.html'),
			controller: ["$scope", "brand","sessionData", function($scope, brand, sessionData) {
				switch (brand.current.sharedBrandCode) {
					case "hmbcbs":
					case "nepa":
						$scope.content = {
					    	"modalTitle": "Highmark has health care providers that are right for you.",
					        "findDoctor" : {
				                "url": (sessionData && sessionData.appConfig && sessionData.appConfig.SPLASH && sessionData.appConfig.SPLASH.NEW_PVD_HREF && sessionData.appConfig.SPLASH.NEW_PVD_HREF.booleanValue && sessionData.appConfig.SPLASH.NEW_PVD_HREF.overrideValue) ? sessionData.appConfig.SPLASH.NEW_PVD_HREF.overrideValue : "/find-a-doctor/#/home",
				                "target":"_blank"
				            },
					        "findPharmacy" : {
					            "premierPharmPrevHref" : "http://www.medcohealth.com/medco/consumer/mybenefits/pl.jsp?memtype=hmkgold",
					            "premierPharmCurrentHref" : "https://host1.medcohealth.com/medco/consumer/mybenefits/pl.jsp?memtype=hmkgold3",
					            "focusedPharmHref" : "http://www.medco.com/medco/consumer/mybenefits/clientPl.jsp?globNav=0&memberNo=OEFOCUSPPOLKUP&memtype=openenrollment",
					            "medicarePharmHref" : "https://host1.medcohealth.com/medco/consumer/mybenefits/medPPOEntry.jsp?memtype=hmk",
								"nationalPlusNetworkHref" : "https://www.express-scripts.com/medco/consumer/mybenefits/medPPOEntry.jsp?memtype=HMKBPREMIEROB",
								"nationalNetworkHref" : "https://www.express-scripts.com/medco/consumer/mybenefits/medPPOEntry.jsp?memtype=HMKBPremier",
								"advantageNetworkHref" : "https://www.express-scripts.com/medco/consumer/mybenefits/medPPOEntry.jsp?memtype=HMKBFocus",
								"medicareNetworkHref" : "https://host1.medcohealth.com/medco/consumer/mybenefits/medPPOEntry.jsp?memtype=hmk"
					        },
					        "findEyeCare": "/login/#/vision-provider-search",
					        "findDentist" : {
					            "advantageHref" : "https://secure.ucci.com/tp2fad/?network=070&lang=en&brandid=HM1-",
					            "advantagePlusHref" : "https://secure.ucci.com/tp2fad/?network=074&lang=en&brandid=HM1-",
					            "allianceHref" : "https://secure.ucci.com/tp2fad/?network=2&lang=en&brandid=HM1-"
					        },
					        "findDrug" : {
					            "preReform" : {
					                "progressiveDrugHref" : "http://client.formularynavigator.com/clients/highmark/commercial_20111001.html",
					                "comprehensiveDrugHref" : "http://client.formularynavigator.com/clients/highmark/commercial.html",
					                "medicareDrugHref" : "http://client.formularynavigator.com/clients/hm/default.html"
					            },
					            "postReform" : {
					                "progressiveDrugPostReformHref" : "http://client.formularynavigator.com/Search.aspx?siteCode=1791332925",
					                "comprehensiveDrugPostReformHref" : "http://client.formularynavigator.com/Search.aspx?siteCode=1788724309"
					            }
					        }
						};
						break;
					case "hmbcbswv":
						$scope.content = {
					    	"modalTitle": "Highmark has health care providers that are right for you.",
					        "findDoctor" : {
				                "url": (sessionData && sessionData.appConfig && sessionData.appConfig.SPLASH && sessionData.appConfig.SPLASH.NEW_PVD_HREF && sessionData.appConfig.SPLASH.NEW_PVD_HREF.booleanValue && sessionData.appConfig.SPLASH.NEW_PVD_HREF.overrideValue) ? sessionData.appConfig.SPLASH.NEW_PVD_HREF.overrideValue : "https://provdir.highmarkbcbswv.com/?brand=HWV",
				                "target":"_blank"
				            },
					        "findPharmacy" : {
					            "premierPharmPrevHref" : "http://www.medcohealth.com/medco/consumer/mybenefits/pl.jsp?memtype=hmkgold",
					            "premierPharmCurrentHref" : "https://host1.medcohealth.com/medco/consumer/mybenefits/pl.jsp?memtype=hmkgold3",
								"nationalPlusNetworkHref" : "https://www.express-scripts.com/medco/consumer/mybenefits/medPPOEntry.jsp?memtype=HMKBPREMIEROB",
								"nationalNetworkHref" : "https://www.express-scripts.com/medco/consumer/mybenefits/medPPOEntry.jsp?memtype=HMKBPremier",
								"advantageNetworkHref" : "https://www.express-scripts.com/medco/consumer/mybenefits/medPPOEntry.jsp?memtype=HMKBFocus",
								"medicareNetworkHref" : "https://host1.medcohealth.com/medco/consumer/mybenefits/medPPOEntry.jsp?memtype=hmk"


					        },
					        "findEyeCare": "http://www.davisvision.com/",
					        "findDentist" : {
					            "sectionHref" : "https://secure.ucci.com/ducdws/home.xhtml"
					        },
					        "findDrug" : {
					            "postReform" : {
					                "progressiveDrugPostReformHref" : "http://client.formularynavigator.com/Search.aspx?siteCode=4909431197",
					                "comprehensiveDrugPostReformHref" : "http://client.formularynavigator.com/Search.aspx?siteCode=4906449921"
					            }
					        }
					    };
						break;
					case "hmbcbsde":
						$scope.content = {
					    	"modalTitle": "Highmark has health care providers that are right for you.",
				            "findDoctor" : {
				                "url": (sessionData && sessionData.appConfig && sessionData.appConfig.SPLASH && sessionData.appConfig.SPLASH.NEW_PVD_HREF && sessionData.appConfig.SPLASH.NEW_PVD_HREF.booleanValue && sessionData.appConfig.SPLASH.NEW_PVD_HREF.overrideValue) ? sessionData.appConfig.SPLASH.NEW_PVD_HREF.overrideValue : "/find-a-doctor/#/home",
				                "target":"_blank"
				            },
					        "findPharmacy" : {
					            "premierPharmPrevHref" : "http://www.medcohealth.com/medco/consumer/mybenefits/pl.jsp?memtype=hmkgold",
					            "premierPharmCurrentHref" : "https://host1.medcohealth.com/medco/consumer/mybenefits/pl.jsp?memtype=hmkgold3",
					            "focusedPharmHref" : "http://www.medco.com/medco/consumer/mybenefits/clientPl.jsp?globNav=0&memberNo=OEFOCUSPPOLKUP&memtype=openenrollment",
					            "medicarePharmHref" : "https://host1.medcohealth.com/medco/consumer/mybenefits/medPPOEntry.jsp?memtype=hmk",
								"nationalPlusNetworkHref" : "https://www.express-scripts.com/medco/consumer/mybenefits/medPPOEntry.jsp?memtype=HMKBPREMIEROB",
								"nationalNetworkHref" : "https://www.express-scripts.com/medco/consumer/mybenefits/medPPOEntry.jsp?memtype=HMKBPremier",
								"advantageNetworkHref" : "https://www.express-scripts.com/medco/consumer/mybenefits/medPPOEntry.jsp?memtype=HMKBFocus",
								"medicareNetworkHref" : "https://host1.medcohealth.com/medco/consumer/mybenefits/medPPOEntry.jsp?memtype=hmk"
					        },
					        "findEyeCare": "/login/#/vision-provider-search",
					        "findDrug" : {
					            "preReform" : {
					                "comprehensiveDrugHref" : "https://client.formularynavigator.com/Search.aspx?siteCode=1546534148"
					            },
					            "postReform" : {
					                "comprehensiveDrugPostReformHref" : "http://client.formularynavigator.com/Search.aspx?siteCode=7597050967"
					            }
					        }
					    };
						break;
					case "hbs":
						$scope.content = {
					    	"modalTitle": "Highmark has health care providers that are right for you.",
				            "findDoctor" : {
				                "url": (sessionData && sessionData.appConfig && sessionData.appConfig.SPLASH && sessionData.appConfig.SPLASH.NEW_PVD_HREF && sessionData.appConfig.SPLASH.NEW_PVD_HREF.booleanValue && sessionData.appConfig.SPLASH.NEW_PVD_HREF.overrideValue) ? sessionData.appConfig.SPLASH.NEW_PVD_HREF.overrideValue : "/find-a-doctor/#/home",
				                "target":"_blank"
				            },
					        "findPharmacy" : {
					            "premierPharmPrevHref" : "http://www.medcohealth.com/medco/consumer/mybenefits/pl.jsp?memtype=hmkgold",
					            "premierPharmCurrentHref" : "https://host1.medcohealth.com/medco/consumer/mybenefits/pl.jsp?memtype=hmkgold3",
					            "focusedPharmHref" : "http://www.medco.com/medco/consumer/mybenefits/clientPl.jsp?globNav=0&memberNo=OEFOCUSPPOLKUP&memtype=openenrollment",
					            "medicarePharmHref" : "https://host1.medcohealth.com/medco/consumer/mybenefits/medPPOEntry.jsp?memtype=hmk",
								"nationalPlusNetworkHref" : "https://www.express-scripts.com/medco/consumer/mybenefits/medPPOEntry.jsp?memtype=HMKBPREMIEROB",
								"nationalNetworkHref" : "https://www.express-scripts.com/medco/consumer/mybenefits/medPPOEntry.jsp?memtype=HMKBPremier",
								"advantageNetworkHref" : "https://www.express-scripts.com/medco/consumer/mybenefits/medPPOEntry.jsp?memtype=HMKBFocus",
								"medicareNetworkHref" : "https://host1.medcohealth.com/medco/consumer/mybenefits/medPPOEntry.jsp?memtype=hmk"
					        },
					        "findEyeCare": "/login/#/vision-provider-search",
					        "findDentist" : {
					            "advantageHref" : "https://secure.ucci.com/tp2fad/?network=070&lang=en&brandid=HM2-",
					            "advantagePlusHref" : "https://secure.ucci.com/tp2fad/?network=074&lang=en&brandid=HM2-",
					            "allianceHref" : "https://secure.ucci.com/tp2fad/?network=2&lang=en&brandid=HM2-"
					        },
					        "findDrug" : {
					            "preReform" : {
					                "progressiveDrugHref" : "http://client.formularynavigator.com/clients/highmark/commercial_20111001.html",
					                "comprehensiveDrugHref" : "http://client.formularynavigator.com/clients/highmark/commercial.html",
					                "medicareDrugHref" : "http://client.formularynavigator.com/clients/hm/default.html"
					            },
					            "postReform" : {
					                "progressiveDrugPostReformHref" : "http://client.formularynavigator.com/Search.aspx?siteCode=1791332925",
					                "comprehensiveDrugPostReformHref" : "http://client.formularynavigator.com/Search.aspx?siteCode=1788724309"
					            }
					        }
					    };
						break;
					case "mincr":
						$scope.content = {
					        "modalTitle": "Blue Cross and Blue Shield of Minnesota and Blue Plus have health care providers that are right for you.",
					        "findDoctor": {
				                "url": (sessionData && sessionData.appConfig && sessionData.appConfig.SPLASH && sessionData.appConfig.SPLASH.NEW_PVD_HREF && sessionData.appConfig.SPLASH.NEW_PVD_HREF.booleanValue && sessionData.appConfig.SPLASH.NEW_PVD_HREF.overrideValue) ? sessionData.appConfig.SPLASH.NEW_PVD_HREF.overrideValue : "/pvd/",
				                "target":"_blank"
				            },
					        "findPharmacy" : {
					            "pharmacyHeader":"Want to find a pharmacy near where you live or work? See your benefit booklet for your pharmacy network.",
					            "findAPharmacyHref" : "https://www.myprime.com/v/BCBSMN/COMMERCIAL/en/find-pharmacy.html",
					            "pharmacyFooter":"Please note: These pharmacies participate in our standard pharmacy networks; pharmacy participation can vary depending on the pharmacy network selected for you plan design."
					        },
				            "findDentist" : {
				                "dentalOverrideContent":"<p>Dental health is important to well-being. All Blue Cross dental plans, use the <a class='find-a-dentist-link-href' href='https://mn.ourdentalcoverage.com/find-a-dentist/' target='_blank'>Advantage Plus 2.0</a> network.</p>",
				                "dentalOverrideFooter":"You will be leaving our website and entering the United Concordia website to view the providers directory. United Concordia is a separate company contracted to provide the dental network of providers for Blue Cross Blue Shield of Minnesota."
				            },
				            "findDrug" : {
					            "findDrugHeader":"A drug formulary is a preferred list of drugs that cost you less out-of-pocket. Drugs are listed by brand and generic names. See your benefit booklet for your formulary.",
					            "findADrugHref":"https://www.myprime.com/v/BCBSMN/COMMERCIAL/en/find-medicine.html"
					        }
					    };
						break;
					case "hhic":
					case "fl":
					case "lou":
					case "az":
					case "la":
					case "neb":
					case "exc":
					case "regbcbs":
					case "regbs":
					case "wi":
					case "hz":
					case "inac":
					case "mn":
					case "pp":
						$scope.content = {
				            "findDoctor" : {
				                "url": (sessionData && sessionData.appConfig && sessionData.appConfig.SPLASH && sessionData.appConfig.SPLASH.NEW_PVD_HREF && sessionData.appConfig.SPLASH.NEW_PVD_HREF.booleanValue && sessionData.appConfig.SPLASH.NEW_PVD_HREF.overrideValue) ? sessionData.appConfig.SPLASH.NEW_PVD_HREF.overrideValue : "https://provdir.mybenefitshome.com",
				                "target":"_blank"
				            },
					        "findPharmacy" : {
					            "premierPharmPrevHref" : "http://www.medcohealth.com/medco/consumer/mybenefits/clientPl.jsp?globNav=0&memberNo=OEP2012PPOLKUP&memtype=openenrollment",
					            "premierPharmCurrentHref" : "http://www.medcohealth.com/medco/consumer/mybenefits/clientPl.jsp?globNav=0&memberNo=1234567899&memtype=openenrollment",
					            "futureScriptsPharmHref" : "https://www.futurescripts.com/FutureScripts/",
								"nationalPlusNetworkHref" : "https://www.express-scripts.com/medco/consumer/mybenefits/medPPOEntry.jsp?memtype=HMKBPREMIEROB",
								"nationalNetworkHref" : "https://www.express-scripts.com/medco/consumer/mybenefits/medPPOEntry.jsp?memtype=HMKBPremier",
								"advantageNetworkHref" : "https://www.express-scripts.com/medco/consumer/mybenefits/medPPOEntry.jsp?memtype=HMKBFocus"
					        },
					        "findDrug" : {
					            "sectionHref" : "http://client.formularynavigator.com/Search.aspx?siteCode=1158840676"
					        }
					    };
						break;
				}
				// hide 2015 networks after December, 2016
				$scope.showFifteenNetworks=new Date().getFullYear() < 2017 ? true : false;
			}]
		});
	};

    var shopPrePasswordHomeLink = link.set("shopPrePasswordHome", {
        "label": "Home",
        "url": "/",
        "icon": true,
        "filterData": {
        	"brand": ['hmbcbs', 'hbs','nepa', 'hmbcbswv', 'hhic', 'fl', 'lou', 'az', 'neb', 'exc', 'regbcbs', 'regbs', 'wi', 'hz', 'inac', 'hmbcbsde', 'ibccr', 'ibcah', 'mn', 'mincr', 'la'],
        	"portal": "shop"
        }
    });
    var shopRewriteHome = link.set("shopPrePasswordHome", {
        "label": "Home",
        "url": "./#!/sbcs",
        "icon": true,
        "filterData": {
            "brand": [ 'unbrandedhm'],
            "portal": "shop"
        }
    });
    var shopSBCs = link.set("shopSBCs", {
        "label": "SBCs",
        "url": "./#!/sbcs",
        "newWindow": false,
        "filterData": {
            "brand": [ 'unbrandedhm'],
            "portal": "shop"
        }
    });
    var shopAgreements = link.set("shopAgreements", {
        "label": "Agreements",
        "url": "./#!/sbc-agreements",
        "newWindow": false,
        "filterData": {
            "brand": [ 'unbrandedhm'],
            "portal": "shop"
        }
    });
    var shopPrePasswordDiscoverLink = link.set("shopPrePasswordDiscover", {
        "label": "Discover",
        "url": "http://discoverhighmark.com/",
        "newWindow": true,
        "filterData": {
        	"brand": ['hmbcbs', 'hbs','nepa', 'hmbcbswv', 'hhic', 'fl', 'lou', 'az', 'neb', 'exc', 'regbcbs', 'regbs', 'wi', 'hz', 'inac', 'hmbcbsde', 'mn', 'la'],
        	"portal": "shop"
        }
    });
    var shopPrePasswordShopLink = link.set("shopPrePasswordShop", {
        "label": "Shop",
        "url": "http://shop.highmark.com/",
        "newWindow": true,
        "filterData": {
        	"brand": ['hmbcbs', 'hbs','nepa', 'hmbcbswv', 'hhic', 'fl', 'lou', 'az', 'neb', 'exc', 'regbcbs', 'regbs', 'wi', 'hz', 'inac', 'hmbcbsde', 'mn', 'la'],
        	"portal": "shop"
        }
    });
    var shopPrePasswordShopmnLink = link.set("shopPrePasswordShopmn", {
        "label": "Shop Plans",
        "url": "https://shop.bluecrossmnonline.com",
        "newWindow": true,
        "filterData": {
        	"brand": ['mincr'],
        	"portal": "shop"
        }
    });
	var shopPrePasswordAdditionalLink = link.set("shopPrePasswordAdditional", {
		"label": "Additional Links",
		"url": false,
		"mSite": false,
		"filterData": {
			"brand": ['*'],
			"portal": "shop"
		},
		"links": [
			{"url":"/login/#/customerService/contact-us", "label":"Customer Service", "newWindow": true, "filterData": {"brand": ['hmbcbs', 'hbs', 'hmbcbswv', 'hhic', 'fl', 'lou', 'az', 'neb', 'exc', 'regbcbs', 'regbs', 'wi', 'hz', 'inac', 'hmbcbsde', 'ibccr', 'ibcah', 'mn', 'mincr', 'la']}},
			{"url":"/login/#/customerService/contact-us", "label":"Customer Service", "newWindow": true, "filterData": {"brand": ['hmbcbswv', 'pp']}},
			{"url":"https://www.independencenationalalliance.com", "label":"Customer Service", "newWindow": true, "filterData": {"brand": ['inac']}},

			{"url":"http://www.highmarkdirect.com", "label":"Find a Direct Store", "newWindow": true, "filterData": {"brand": ['hmbcbs', 'hbs']}},
			{"url":"https://www.bluecrossmn.com/store", "label":"Retail Store", "newWindow": true, "filterData": {"brand": ['mincr']}},
			{"url":"https://www.highmark.com/hmk2/about/vision/index.shtml", "label":"About Highmark", "newWindow": true, "filterData": {"brand": ["hmbcbs", "hbs", "hmbcbswv", "hhmbcbsde"]}},
			{"url":"https://www.bluecrossmn.com/healthy/public/personal/home/about-us", "label":"About Us", "newWindow": true, "filterData": {"brand": ['mincr']}},

			{"url":"https://www.highmark.com/hmk2/privacy.shtml", "label":"Privacy Policy", "newWindow": true, "filterData": {"brand": ["hmbcbs", "hbs"]}},
			{"url":"http://www.athighmark.com/privacy/wv/index.shtml", "label":"Privacy Policy", "newWindow": true, "filterData": {"brand": ["hmbcbswv"]}},
			{"url":"http://www.athighmark.com/privacy/de/index.shtml", "label":"Privacy Policy", "newWindow": true, "filterData": {"brand": ["hmbcbsde"]}},
			{"url":"https://www.mybenefitshome.com/pdffiles/OnlinePrivacyPolicy_MBH.pdf", "label":"Privacy Policy", "newWindow": true, "filterData": {"brand": ['pp']}},

			{"url":"https://www.highmark.com/health/professionals/medical-policy/medical-policy-acceptance.html", "label":"Medical Policy", "newWindow": true, "filterData": {"brand": ["hmbcbs"]}},
			{"url":"/content/dam/highmark/en/highmarkblueshield/member/medicalpolicy/hbs-medical-policy-acceptance.html", "label":"Medical Policy", "newWindow": true, "filterData": {"brand": ["hbs"]}},
			{"url":"https://www.highmark.com/health/professionals/delaware-commercial-medical-policy/medical-policy-acceptance.html", "label":"Medical Policy", "newWindow": true, "filterData": {"brand": ["hhmbcbsde"]}},
			{"url":"/vk2luv/pages/search.jsp?content=MEDICALPOLICY&context=UNBRANDED&region=ALL&resource=BCBSA&user=PUBLIC", "label":"Medical Policy", "newWindow": true, "filterData": {"brand": ["pp"]}},
			{"url":"https://www.independencenationalalliance.com/vk2luv/pages/search.jsp?content=MEDICALPOLICY&context=UNBRANDED&region=ALL&resource=BCBSA&user=PUBLIC", "label":"Medical Policy", "newWindow": true, "filterData": {"brand": ["inac"]}},

			{"url":"/accessibility/accessibility_wpa.html", "label":"Accessibility", "newWindow": true, "filterData": {"brand": ["hmbcbs"]}},
			{"url":"/accessibility/accessibility_cre.html", "label":"Accessibility", "newWindow": true, "filterData": {"brand": ["hbs"]}},
			{"url":"/accessibility/accessibility_mbh.html", "label":"Accessibility", "newWindow": true, "filterData": {"brand": ["hmbcbswv"]}},
			{"url":"/accessibility/accessibility_de.html", "label":"Accessibility", "newWindow": true, "filterData": {"brand": ["hhmbcbsde"]}},
			{"url":"/accessibility/accessibility_mbh.html", "label":"Accessibility", "newWindow": true, "filterData": {"brand": ["pp"]}},
			{"url":"https://www.independencenationalalliance.com/accessibility/accessibility_mbh.html", "label":"Accessibility", "newWindow": true, "filterData": {"brand": ["inac"]}},

			{"url":"https://www.highmark.com/hmk2/texting.shtml", "label":"SMS Texting", "newWindow": true, "filterData": {"brand": ['hmbcbs', 'hbs', 'hmbcbswv', 'hhic', 'fl', 'lou', 'az', 'neb', 'exc', 'regbcbs', 'regbs', 'wi', 'hz', 'inac', 'hmbcbsde', 'ibccr', 'ibcah', 'mn', 'la']}},
			{"url":"/texting.html", "label":"SMS Texting", "newWindow": true, "filterData": {"brand": ['pp']}},
			{"url":"https://www.independencenationalalliance.com/texting.html", "label":"SMS Texting", "newWindow": true, "filterData": {"brand": ['inac']}},

			{"url":"https://www.highmark.com/hmk2/terms.shtml", "label":"Terms of Service", "newWindow": true, "filterData": {"brand": ["hmbcbs", "hbs", "hmbcbswv", "hhmbcbsde"]}},
			{"url":"https://www.mybenefitshome.com/pdffiles/terms_of_service.pdf", "label":"Terms of Service", "newWindow": true, "filterData": {"brand": ['pp']}},

			{"url":"https://www.highmark.com/hmk2/fraud/index.shtml", "label":"Fraud Prevention", "newWindow": true, "filterData": {"brand": ["hmbcbs", "hbs", "hmbcbswv", "hhmbcbsde"]}},
			{"url":"https://www.highmark.com/hmk2/hipaa/index.shtml", "label":"HIPAA", "newWindow": true, "filterData": {"brand": ["hmbcbs", "hbs", "hmbcbswv", "hhmbcbsde"]}},
			{"onClick": function() {}, "label":"Find a Doctor or Rx", "filterData": {"brand": ["pp"]}}
		],
		"linkFilters": ["brand", "msite", "postPassword", "portal"]
	});
    var shopPrePasswordFindDoctorLink = link.set("shopPrePasswordFindDoctor", {
        "label": "Find a Doctor or RX",
        "onClick": findDoctorModal,
        "filterData": {
        	"brand": ['hmbcbs', 'hbs','nepa', 'hmbcbswv', 'hhic', 'fl', 'lou', 'az', 'neb', 'exc', 'regbcbs', 'regbs', 'wi', 'hz', 'inac', 'hmbcbsde', 'ibccr', 'ibcah', 'mn', 'mincr', 'la'],
        	"portal": "shop"
        }
    });
    var shopPrePasswordMedicareLink = link.set("shopPrePasswordMedicare", {
        "label": "Medicare",
        "url": "http://shop.highmark.com/medicare",
        "newWindow": true,
        "filterData": {
        	"brand": ['hmbcbs', 'hbs','nepa', 'hmbcbswv', 'hhic', 'fl', 'lou', 'az', 'neb', 'exc', 'regbcbs', 'regbs', 'wi', 'hz', 'inac', 'hmbcbsde', 'mn', 'la'],
        	"portal": "shop"
        }
    });

	var portalFilter = navigation.setFilter("portal", function(item) {
		return "shop" == item.filterData.portal;
	});

    var entitlementsFilter = navigation.setFilter("entitlements", function(item){
        var entitlementArray = sessionData.loginData.entitlements;
        if(item.filterData){
            //return (item.filterData.entitlements.indexOf(sessionData.loginData.entitlements) > -1 ? true : false);
            if(entitlementArray.indexOf(item.filterData.entitlements) > -1){
                return true;
            }
            else{
                return false;
            }
        }
        return true;
    });

	var headerTabs = navigation.set("headerTabs");
	headerTabs.linkFilters.push("brand", "postPassword", "portal", "tempPassword");
	headerTabs.links.push(
         shopPrePasswordHomeLink, shopRewriteHome, shopSBCs, shopAgreements, shopPrePasswordDiscoverLink, shopPrePasswordShopLink, shopPrePasswordShopmnLink, shopPrePasswordAdditionalLink, shopPrePasswordFindDoctorLink, shopPrePasswordMedicareLink
	);

	var footerLinks = navigation.set("footerLinks");
	footerLinks.linkFilters.push("brand", "postPassword", "portal", "tempPassword");
	footerLinks.links.push(
		shopPrePasswordDiscoverLink,  shopRewriteHome, shopSBCs, shopAgreements, shopPrePasswordShopLink, shopPrePasswordShopmnLink, shopPrePasswordAdditionalLink, shopPrePasswordFindDoctorLink, shopPrePasswordMedicareLink
	);

        hook.register('eBusinessSessionStart', [
			"$cookies",
			"teamsite",
			"brand",
			"coremetrics",
			"services",
			"$q",
			"sessionData",
			"brandConfig",
			"$interval",
			"session",
			"appConfig",
			"$state",
			"SALES_CONSTANTS",
			"storage",
			function(
				$cookies,
				teamsite,
				brand,
				coremetrics,
				services,
				$q,
				sessionData,
				brandConfig,
				$interval,
				session,
				appConfig,
				$state,
				SALES_CONSTANTS,
				storage
			) {
				
        	var ltpaServiceRoles = ["agent", "agency_admin", "internal", "member"];
        	var userInfoServiceRoles = ["visitor"];
			var allRoles = ltpaServiceRoles.concat(userInfoServiceRoles);
			
			var useCommerceLogin = storage.get(SALES_CONSTANTS.commerce.useLogin);
			
        	/****
        	 * LTPA login needs to be called to get CommerceTokens for /wcs services
        	 * However, when you are a producer going to the SHOP-U65 site, we save tokens to sessionStorageService (so we don't lose values between portals)
        	 *  we break out the flow such that LTPA is only called if producer and not on shop 4.0 site
        	 ****/
        	var loginPromisesObj = {};

        	if (appId.toUpperCase() !== "CHMSHP" && appId.toUpperCase() !== "MEDWEB") {
				
				var logonId = session && session.data && session.data.basicInfo && session.data.basicInfo.loginId;
				var payload = {UserID: logonId};
				if (useCommerceLogin) {
					loginPromisesObj['ltpalogin'] = services.wcs.ltpalogin({"storeId": brand.current.storeId}).postData();
				} else {
					loginPromisesObj['userInfo'] = services.rbsmbl.getUserInfo().fetch(payload);
				}
        	} else if (appId.toUpperCase() === "CHMSHP") {
        		var role 			= sessionData.basicInfo.role.toUpperCase();
        		var producerRoles 	= ["AGENT", "AGENCY_ADMIN", "INTERNAL"];

        		// IF   - Producer
    			if (producerRoles.indexOf(role.toUpperCase()) !== -1) {
    				// Get value from sessionStorageService (initially set in CHMPRD - producer portal)
    				loginPromisesObj['sessionStorageService'] 	= services.cmcrst.getSessionStorageData({"userType":"PRODUCER","customerId":"LOGINDATA"}).get();
    			}
    			// ELSE - Consumer
    			else {
    				// Get consumer values
					loginPromisesObj['userLogin'] 				= services.rbsmbl.userLogin().fetch();
    			}
        	} else if (appId.toUpperCase() === "MEDWEB") {
                var role 			= sessionData.basicInfo.role.toUpperCase();
                var producerRoles 	= ["AGENT", "AGENCY_ADMIN", "INTERNAL"];
				var sessionLoginDetails = $cookies.get('producerId');
				
                // IF   - Producer
                if (producerRoles.indexOf(role.toUpperCase()) !== -1 && sessionLoginDetails) {
                    // Get value from sessionStorageService (initially set in CHMPRD - producer portal)
                    loginPromisesObj['sessionStorageService'] 	= services.cmcrst.sessionStorage({"type":"loginData","loginId": sessionLoginDetails}).get();
                } else{
					// Leave this functionality in place because MEDWEB should be retired anyway
					loginPromisesObj['ltpalogin'] = services.wcs.ltpalogin({"storeId": brand.current.storeId}).postData();
					
					//Used for session storage retrival. Any cookies left from prior sessions being cleaned up
					$cookies.remove('producerId');
                }
            }

            if (allRoles.indexOf(sessionData.basicInfo.role.toLowerCase()) !== -1) {
                // if ($cookies.get('LtpaToken2')) {
                    return $q.all(loginPromisesObj).then(function(response) {
						
						var loginData;
						
    					var getCorrectLoginData = function (){

                    		var loginDataDeferred = $q.defer();

                    		/****
                    		 * 3 response types, each have differing payloads,
                    		 * this assists in flattening the responses a bit
                    		 ****/
							
                    		if (response) {
                    			if (response.ltpalogin) {
                    				/****
                    				 * Producer, not U65-Shop (old)
                    				 ****/
					                loginDataDeferred.resolve(response.ltpalogin.data);

                    			} else if (response.userInfo) {
									/****
									 * Producer, not U65-Shop (new)
									 */
									if (
										response.userInfo.data &&
										response.userInfo.data.payload
									) {
										response.userInfo.data.payload.nickName = sessionData.basicInfo.loginId;
										loginDataDeferred.resolve(response.userInfo.data.payload);
									}
								} else if (response.sessionStorageService) {
                    				/****
                    				 * Producer, U65-Shop
                    				 ****/
		                    		var dataObject = response.sessionStorageService.data.payload.sessionStorage.data;
                                    var sessionObject = response.sessionStorageService.data.payload;

		                    		// Re-save for re-retrieval
                                    if(appId.toUpperCase() === "MEDWEB") {
                                        services
                                            .cmcrst
                                            .sessionStoragePut()
                                            .storeSession(sessionObject)
                                            .then(function (setSessionStorageResponse) {
                                                loginDataDeferred.resolve(response.sessionStorageService.data.payload.sessionStorage.data);
                                            }, function (error) {
                                                console.log("No session data for producer user");
                                                loginDataDeferred.resolve(response.sessionStorageService.data.payload.sessionStorage.data);
                                            });
                                    }else{
                                        services
                                            .cmcrst
                                            .setSessionStorageData()
                                            .set("PRODUCER", "LOGINDATA", dataObject)
                                            .then(function (setSessionStorageResponse) {
                                                loginDataDeferred.resolve(response.sessionStorageService.data.payload.sessionStorage.data.loginData);
                                            }, function (error) {
                                                console.log("No session data for producer user");
                                                loginDataDeferred.resolve(response.sessionStorageService.data.payload.sessionStorage.data.loginData);
                                            });
                                    }
                    				
                    			} else if (response.userLogin) {
                    				/****
                    				 * Consumer, U65-Shop
                    				 ****/
									if ($cookies.get("CommerceTokens")) {
										var commerceTokens = JSON.parse($cookies.get("CommerceTokens"));
										angular.extend(response.userLogin.data, commerceTokens);
									}

                    				loginDataDeferred.resolve(response.userLogin.data);
                    			}
                    		}

                    		return loginDataDeferred.promise;
    					};


    					getCorrectLoginData().then(function(loginData){
	                        brand.override = brand.override || loginData.regions[0].brand;


	                        var producerAgencyData = sessionStorage.ProducerAgencyUserData; //$cookies.get('ProducerAgencyUserData');
	                        var selectedAgency = null;
	                        var producerRegionData = sessionStorage.ProducerRegionUserData; //$cookies.get('ProducerRegionUserData');
	                        var selectedRegion = null;
	                        var selectedAgencyRegion = {};

	                        if(producerAgencyData && producerRegionData){
	                            // Agency check if agency modal is used to change the agency
	                            selectedAgency = JSON.parse((producerAgencyData ? producerAgencyData : "null"));
	                            selectedRegion = JSON.parse((producerRegionData ? producerRegionData : "null"));
	                            selectedAgencyRegion.selectedAgency = selectedAgency;
	                            selectedAgencyRegion.selectedRegion = selectedRegion;
	                        }

	                        if(loginData.agencyIdPref && loginData.regionPref && !response.sessionStorageService){
	                        	/****
	                        	 * Not coming from U65 Producer
	                        	 ****/
	                            loginData.regions.forEach(function(region) {
	                                if (region.region === loginData.regionPref) {
	                                    selectedAgencyRegion.selectedRegion = region;
	                                }
	                            });

	                            loginData.agencies.forEach(function(agency) {
	                                if (agency.agencyId === loginData.agencyIdPref) {
	                                    selectedAgencyRegion.selectedAgency = agency;
	                                }
	                            });
	                        } else if (response.sessionStorageService) {
	                        	/****
	                        	 * Assigned these from session storage, when coming U65 producer
	                        	 ****/
	                        	selectedAgencyRegion.selectedAgency = response.sessionStorageService.selectedAgency;
	                        	selectedAgencyRegion.selectedRegion = response.sessionStorageService.selectedRegion;
	                        }

	                        if(selectedAgencyRegion && selectedAgencyRegion.selectedAgency && selectedAgencyRegion.selectedRegion) {
	                        	//getting entitlements for internal users...
	                        	if(sessionData.basicInfo.role.toLowerCase() === "internal" && loginData.agencies && loginData.agencies.length > 0) {
	                        		selectedAgencyRegion.selectedAgency.entitlements = loginData.agencies[0].entitlements;
	                        	}

	                            loginData.selectedAgency = selectedAgencyRegion.selectedAgency;
	                            loginData.selectedRegion = selectedAgencyRegion.selectedRegion;
	                            var i = 0;
	                            for (i = 0; i < loginData.regions.length; i ++) {
	                                if(loginData.selectedRegion.region == loginData.regions[i].region ) {
	                                    brand.override = loginData.regions[i].brand;
	                                     break;
	                                }
	                            }
	                        }

	                        brandConfig.update();

	                        sessionData.loginData = {};

	                        /****
	                         * Add LTPA loginData to session, extend
	                         ****/
	                        if (response.userLogin && response.userLogin.data) {
		                        /****
		                         * Given both LTPA and User Login
		                         * Non-Producer roles
		                         ****/
	                        	var mergedAndFormattedLTPAandUserLoginData = {};
	                        	var userLoginData = angular.copy(response.userLogin.data);
	                        	var ltpaLoginData = angular.copy(loginData);

		                        angular.forEach(ltpaLoginData, function(value, key){
									if (!userLoginData[key]) {
										mergedAndFormattedLTPAandUserLoginData[key] = value;
									} else {
										// conflicting values
										if (typeof ltpaLoginData[key] === 'undefined' || ltpaLoginData[key] === "") {
											// LTPA doesn't provide value for key
											mergedAndFormattedLTPAandUserLoginData[key] = userLoginData[key];
										} else if (typeof userLoginData[key] === 'undefined' || userLoginData[key] === "") {
											// User Login doesn't provide value for key
											mergedAndFormattedLTPAandUserLoginData[key] = ltpaLoginData[key];
										} else {
											if (ltpaServiceRoles.indexOf(sessionData.basicInfo.role.toLowerCase()) === -1) {
												// Non-Producer
												mergedAndFormattedLTPAandUserLoginData[key] = userLoginData[key];
											} else {
												// Producer
												mergedAndFormattedLTPAandUserLoginData[key] = ltpaLoginData[key];
											}
										}
									}
		                        });

		                        angular.forEach(userLoginData, function(value, key){
		                        	if (!mergedAndFormattedLTPAandUserLoginData[key]) {
		                        		mergedAndFormattedLTPAandUserLoginData[key] = value;
		                        	}
		                        });

		                        angular.extend(sessionData.loginData, mergedAndFormattedLTPAandUserLoginData);
							} else if (response.userInfo && response.userInfo.data && response.userInfo.data.payload) {
								angular.extend(sessionData.loginData, response.userInfo.data.payload);
							} else {
		                    	/****
		                    	 * Given only LTPA Login
		                    	 ****/
	                        	angular.extend(sessionData.loginData, loginData);
		                    }
							
							hook.execute('ltpaLoginStarted');    						
    					})
                    }, function(errResponse) {
						if (errResponse.data.errors[0].errorKey === '_ERR_INVALID_COOKIE') {
                            $cookies.put('LtpaToken2', '');
                            location.reload();
                        } else {
                            $cookies.put('LtpaToken2', '');
                            location.reload();
						}
					});
                // }
            }
        }]);
}]);